import { Box, Button, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { TextFieldComponent } from "../../../common/TextFieldComponent";
import { updateProvider } from "../helpers/updateProvider";
import { useModals } from "../../../../context/ModalContext";

const REGEX_LETTERS_ONLY = /^[A-Za-zÀ-ÿ0-9\s]+$/;
const REGEX_ADDRESS = /^[A-Za-zÀ-ÿ0-9\s.,#°\-]+$/;

export const EditProvider = ({ modalKey, provider, onSuccess, onClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nameProvider: provider.name,
      addressProvider: provider.address,
    },
  });
  const { closeByKey } = useModals()


  const token = sessionStorage.getItem("token");

  const onSubmit = async (data) => {
    try {
      await updateProvider({
        token,
        id: provider.id,
        data: {
          name: data.nameProvider,
          address: data.addressProvider,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };


  const handleFormSubmit = handleSubmit(async (data) => {
    try {
      await onSubmit(data);
      closeByKey(modalKey);
    } catch (err) {
      console.error(err);
    }
  });



  return (
    <Box sx={{ padding: "15px" }}>
      <Typography variant="h4" sx={{ marginBottom: "30px" }}>
        Edit Provider
      </Typography>
      <Box component={"form"} onSubmit={handleFormSubmit} sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item md={12}>
            <TextFieldComponent
              name="nameProvider"
              errors={errors}
              register={register("nameProvider", {
                required: "Name is required",
                minLength: {
                  value: 3,
                  message: "Minimum of three characters",
                },
                pattern: {
                  value: REGEX_LETTERS_ONLY,
                  message: "Only letters and numbers allowed",
                },
              })}
              label="Provider Name"
              inputLabel="Provider Name"
              type="text"
            />
          </Grid>

          <Grid item md={12}>
            <TextFieldComponent
              name="addressProvider"
              errors={errors}
              register={register("addressProvider", {
                required: "Provider Address is required",
                minLength: {
                  value: 3,
                  message: "Minimum of three characters",
                },
                pattern: {
                  value: REGEX_ADDRESS,
                  message: "Only valid characters allowed",
                },
              })}
              label="Address Provider"
              inputLabel="Address Provider"
              type="text"
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
          <Button onClick={() => closeByKey(modalKey)} variant="outlined">
            Cancel
          </Button>
          <Button variant="contained" type="submit" sx={{ backgroundColor: "#0f188d" }}>
            Save
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
